import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Typography } from '@mui/material';
import login_hand from 'assets/images/login_hand.png';
import logo from 'assets/images/companyLogo.svg';
import { companyDetails } from 'utils/companyDetails';
import { getBranding } from 'config/tenantConfig';

export default function WelcomeITER() {
    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate('/compliance/5?upload=true')
    }
  return (
    <>
      <Box sm={{ flexGrow: 1 }} className="">
        <Grid container spacing={2}>
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
              sx={{ display: { xs: 'none', sm: 'flex' }, alignItems: 'center' }}
            >
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="flex-start"
              >
                <Grid container item alignItems="center">
                  <img src={getBranding().logo || companyDetails?.companyLogo} className="logoImg" alt="otplogo" />
                </Grid>
              </Grid>
            </Box>
            {/* ---login input type--- */}
            <div className=" ">
              <Grid
                container
                direction='row'
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={7} xs={12} className="textCenter">
                  <img src={login_hand} alt="hand" />
                  <Typography className="fontMedium font36 colorBlue">
                  Welcome to <span className='colotYellow'>{companyDetails?.companyName}</span>
                  </Typography>
                  <Typography className=" font18">
                  These all benefits ITER going to provide
                  </Typography>
                </Grid>
              
              <Grid item sm={8} xs={12}>
                <ul className='colorGrey'>
                    <li>It's a cab booking app, you can easily book a cab from anywhere at any time, eliminating the need to wait on the street or make phone calls to book a cab. </li>
                    <li>Cab booking apps are designed with user-friendly interfaces, making it simple and intuitive to book a cab with just a few taps on your smartphone.</li>
                    <li>The app saves you time by instantly connecting you with available cabs nearby, avoiding the need to search or wait for a cab to pass by.</li>
                    <li>Cab booking apps provide access to a network of reliable and licensed drivers, ensuring prompt and efficient service.</li>
                    <li>Many cab booking apps incorporate GPS technology, allowing you to track the real-time location of your assigned cab and estimate its arrival time accurately.</li>
                </ul>
              </Grid>
              <Grid item sm={7} xs={12} className="textCenter">
                <Button className='chooseBtn' onClick={handleRedirect}>Continue</Button>
              </Grid>
              </Grid>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid
            item
            sm={6}
            sx={{ display: { xs: 'none', sm: 'flex' } }}
            className="bgImage"
          >
            <div className="loginBgImg"></div>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
